
import AlignHorizontally from "../../../assets/duotone/AlignHorizontally.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AlignHorizontallyIcon({ className, dataTestid = "AlignHorizontallyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AlignHorizontally data-testid={dataTestid} className={classes} {...rest} />
  );
}
